// extracted by mini-css-extract-plugin
module.exports = {"chip":"_1NuJR3akBD0sdu3MPgIMsU","socialChipIcon":"_3K6R3_o-HgfF0QlBXmnHPR"};